module.exports = __webpack_public_path__ + "img/header-profile.02c5efcd.svg";